import type {
  PathAnalyticsQueryResponse,
  PathAnalyticsQueryVariables,
} from '~/api/graphql/queries/pathAnalytic.generated';
import type { PathAnalyticSelectFragment } from '~/api/graphql/fragments/pathAnalytic.generated';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { UseQueryOptions } from '@tanstack/react-query';

import { PathAnalyticsDocument } from '~/api/graphql/queries/pathAnalytic.generated';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomPathAnalyticsResponse extends PathAnalyticsQueryResponse {
  pathAnalytics: PathAnalyticSelectFragment[];
  headers: BaseHeaderResponse;
}

export const useCustomPathAnalyticsQuery = <TData = CustomPathAnalyticsResponse, TError = unknown>(
  variables: PathAnalyticsQueryVariables,
  options?: UseQueryOptions<CustomPathAnalyticsResponse, TError, TData>,
) => {
  return useQuery<CustomPathAnalyticsResponse, TError, TData>(
    ['PathAnalyticsCustom', variables],
    appFetcherCustom<CustomPathAnalyticsResponse, PathAnalyticsQueryVariables>(
      PathAnalyticsDocument,
      variables,
    ),
    options,
  );
};

useCustomPathAnalyticsQuery.getKey = (variables?: PathAnalyticsQueryVariables) => [
  'PathAnalyticsCustom',
  variables,
];
